import React from 'react'
import RegisterAccount from 'src/app/RegisterAccount/RegisterAccount'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { registerAccountRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const RegisterAccountAppRoute: AppRoute = {
  id: AppLocation.RegisterAccount,
  routeProps: registerAccountRouteProps,
  component: <RegisterAccount />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default RegisterAccountAppRoute
